
import { createSelector } from '@reduxjs/toolkit';
import { GlobalDataState } from '../reducers/global-data';

type State = { globalData: GlobalDataState };

export const getRootConfig = createSelector(
  (state: State) => state.globalData,
  (globalData) => (globalData.loaded ? globalData.data.config : undefined)
);
